import { useMemo } from 'react';
import { ApiClient } from './client';
import { useApiToken } from '../auth/useApiToken';

/**
 * Stellt einen memoisierten ApiClient bereit, der das aktuelle
 * Token-Beschaffungs-Callback verwendet.
 */
export function useApi(): ApiClient {
  const getToken = useApiToken();
  return useMemo(() => new ApiClient(getToken), [getToken]);
}
